/* eslint-disable eqeqeq */
const symToStringTag = Symbol ? Symbol.toStringTag : undefined;
export var isArray = Array.isArray;

const asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]';

const objectProto = Object.prototype;

const hasOwnProperty = objectProto.hasOwnProperty;

const nativeObjectToString = objectProto.toString;

function objectToString(value) {
    return nativeObjectToString.call(value);
}

function getRawTag(value) {
    const unmasked = true;
    const isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
        value[symToStringTag] = undefined;
    } catch (e) {}

    const result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) {
            value[symToStringTag] = tag;
        } else {
            delete value[symToStringTag];
        }
    }
    return result;
}

function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

function isObjectLike(value) {
    return value != null && typeof value == 'object';
}

export function isUndefined(value) {
    return value === undefined;
}

export function isNull(value) {
    return value === null;
}

export function isString(value) {
    return typeof value == 'string' || (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

export function isNumber(value) {
    return typeof value == 'number' || (isObjectLike(value) && baseGetTag(value) == numberTag);
}

export function isBoolean(value) {
    return value === true || value === false || (isObjectLike(value) && baseGetTag(value) == boolTag);
}

function isObject(value) {
    const type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}

export function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    const tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

export function isPrimitive(value) {
    return isNumber(value) || isBoolean(value) || isString(value) || isNull(value) || isUndefined(value);
}
